<template>
	<div id="app">
		<f7-statusbar :theme="statusColor"></f7-statusbar>
		<!-- <left-panel v-if="service.length>4"></left-panel> -->
		<div v-bind:class="{hiddenBlock : !isConnected}" id="panel">
			<left-panel></left-panel>
		</div>
		<f7-views>
			<!-- TLV 09/12/2019
				J'ai mis le paramètre domCache à false pour éviter l'erreur de sélection de compte bancaire
				au deuxième affichage des new request to pay ou direct payments. M'en parler si ça pose problème
			-->
			<f7-view :domCache="false" :uniqueHistory="false" id="main-view" navbar-through :dynamic-navbar="true" main url="/login/">
				<f7-navbar fill :style="titleNavBar">
					<f7-nav-center sliding></f7-nav-center>
				</f7-navbar>
				<f7-pages></f7-pages>
				<bottom-toolbar></bottom-toolbar>
			</f7-view>
		</f7-views>

    <cm-popups></cm-popups>
		<!-- <enroll-message></enroll-message> -->
    <user-guide></user-guide>

	</div>
</template>

<script>
import LeftPanel from '@/components/leftPanel/CMLeftPanel.vue'
// import enrollMessage from '@/components/common/enrollMessage.vue'

// import FormDevis from '@/components/forms/CMDevis.vue'
// import FormReglament from '@/components/forms/CMReglament.vue'

import CMPopup from '@/popups/Popups.vue'

import networkMixin from './mixins/networkMixin'
import userGuidePopovers from '@/components/common/userGuidePopovers.vue'
// import dynamicStyleMixin from './mixins/dynamicStyleMixin'

import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'
/* eslint-disable no-tabs */
/* eslint-disable indent */
export default {
  mixins: [networkMixin], //  dynamicStyleMixin],
  components: {
    'cm-popups': CMPopup,
    'left-panel': LeftPanel,
    // 'cm-devis': FormDevis,
    // 'cm-reglament': FormReglament,
    'user-guide': userGuidePopovers,
    // 'enroll-message': enrollMessage,
    'bottom-toolbar': bottomToolbar
  },
	data: () => {
    return {
      service: '',
			isConnected: false
    }
  },
  created () {
		/** TLV - TBR 27/11/2017
		* Affichage du menu de gauche seulement quand un service est actif,
		* Quand il n'y a pas de service sélectionné (sur la page de connexion par exemple),
		* Le menu de gauche n'est pas affiché
		*
		*/
		this.$engine.services.directPayments.filter.smartphoneStorage = window.innerWidth <= 992
		this.$bus.$on('service:change', () => {
				this.service = this.$engine.user.currentService.name
				this.$bus.$emit('refresh-cache-menu')
			})
    this.$bus.$on('refresh-cache-menu', () => {
      this.service = this.$engine.user.currentService.name
			let clearance = this.$engine.user.get().clearance
			if (clearance !== undefined && clearance.hasOwnProperty(this.service)) {
				let noAccess = true
				if (clearance[this.service] === '0') {
					for (var clear in clearance) {
						if (clearance[clear] !== '0') {
							noAccess = false
						}
					}
					if (noAccess === true) {
						this.$f7.closePanel()
						this.$f7.alert('Your profile does not have any access, please select another profile', 'No access')
						this.$f7.popup('#switch-profile-false')
					} else {
						this.$f7.closePanel()
						this.$f7.alert('Your profile does not have access to this service, please select another', 'No access')
						this.$f7.popup('#service-switcher-false')
					}
				}
			}
    })
  },
  mounted () {
    let that = this
		this.$bus.$on('LogIn', function (login) {
				if (!login && !this.$engine.services.directPayments.filter.smartphoneStorage) {
					this.$engine.user.currentService.name = ''
					// this.service = this.$engine.user.currentService.name
					this.$bus.emit('service:change', '')
				} else if (login) {
					that.isConnected = true
				}
			})
		this.isConnected = this.$engine.auth.user.get().identifier !== ''
		let defaultService = 'Direct Debit'
		let defaultServiceId = parseInt(this.$engine.services.getServiceIdByName(defaultService)) - 1
		if (this.isConnected) {
				this.$engine.user.changeService(this.$engine.services.get()[defaultServiceId])
				this.$bus.emit('service:change', defaultService)
		}
		this.$bus.on('logout', () => {
			that.isConnected = false
			this.$engine.user.connectBy = 'login-password-capi'
			this.logout()
		})
		this.$bus.on('otp-expired', () => {
			this.isConnected = false
			this.$engine.user.connectBy = 'login-password-capi'
			if (this.$engine.services.directPayments.filter.smartphoneStorage) {
				this.$$('.with-panel-left-cover').removeClass('with-panel-left-cover')
				// this.$$('.panel-overlay').css('display', 'none')
			}
			this.$bus.emit('service:change', false)
		})
  },
	methods: {
    logout () {
      let that = this
      that.$f7.showPreloader('Logging out')
      // loadPage(this, {url: '/login/'})
      this.$bus.$emit('service:unset')
      this.$bus.$off('sendbox-filtered')
      this.$bus.$off('refresh-cache-bank-accounts')
      this.$bus.$off('refresh-cache-contacts')
      this.$bus.$off('refresh-cache-attachments')
      this.$bus.$off('refresh-cache-account-members')
      this.$bus.$off('refresh-inbox-list-cache')
      this.$bus.$off('refresh-inbox-on-seen')
      // this.$bus.$off('refresh-cache-menu')
      this.$bus.$emit('LogIn', false)
      this.$engine.auth.logout()
      .then(resp => {
        this.$engine.user.unload()
        that.$f7.hidePreloader()
        if (this.$engine.connectBy === 'vue-google-oauth2') {
          this.$gAuth.signOut()
          let that = this
          .then(() => {
            // On success do something
            that.isSignIn = this.$gAuth.isAuthorized
          })
          .catch(err => {
            // On fail do something
            console.log(err)
          })
        }
        /* TLV 11/12/2019 : Le panneau de gauche reste parfois "ouvert" sur mobile à la déconnexion,
        donc on s'assure qu'il a été retiré pour que l'utilisateur puisse se re-connecter */
        if (this.$engine.services.directPayments.filter.smartphoneStorage) {
          this.$$('.with-panel-left-cover').removeClass('with-panel-left-cover')
          // this.$$('.panel-overlay').css('display', 'none')
        }
        // Purge history on logout
        this.$f7.views.main.history = []
        /* Se trouvait avant dans this.$bus.on('logout', () => {}) */
        this.$bus.emit('service:change', false)
				loadPage(this, {url: '/login/'})
      })
      .catch(err => {
        that.$f7.hidePreloader()
        // Purge history on logout
        this.$f7.views.main.history = []
        loadPage(this, {url: '/login/'})
        // errorMessageAlert(err, that)
        console.log(err)
      })
    }
	},
  computed: {
    statusColor () {
      if (this.online) return ''
      return 'red'
    },
    titleNavBar () {
      let style = { 'background-color': this.servicesColors.DEFAULT }

      if (!this.online) style['background-color'] = '#f44336'

      return style
    }
  },
  notifications: {
    showNetworkOffline: {
      type: 'error',
      title: '',
      message: 'Your device is offline'
    },
    showNetworkOnline: {
      type: 'info',
      title: '',
      message: 'Connection is now available'
    }
  },
  watch: {
    online (isOnline) {
      if (isOnline) {
        this.showNetworkOnline()
      } else {
        this.showNetworkOffline()
      }
    }
	}
}
</script>

<style media="screen">
.hiddenBlock {
	display:none;
}
</style>



// WEBPACK FOOTER //
// App.vue?1a700c22